export class DashboardBrugerKompetenceProgressModel {
    brugerId: string;
    percentage: number;

    static Build(responseModel: DashboardBrugerKompetenceProgressResponseModel): DashboardBrugerKompetenceProgressModel {
        let model = new DashboardBrugerKompetenceProgressModel();
        model.brugerId = responseModel.brugerId;
        model.percentage = responseModel.percentage;
        return model;
    }
}

export type DashboardBrugerKompetenceProgressResponseModel = {
    brugerId: string
    percentage: number
}
